import { getUserDetails } from '../../actions/userActions';
import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

const SessionCheck = ({ sessionId, timeout, getUserDetails }) => {
  const lastCheckRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    lastCheckRef.current = Date.now();

    intervalRef.current = setInterval(() => {
      const now = Date.now();
      if (now >= lastCheckRef.current + timeout * 1000) {
        getUserDetails(sessionId);
        lastCheckRef.current = now;
      }
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [timeout, sessionId, getUserDetails]);

  return null;
};

const mapStateToProps = (state) => ({
  sessionId: state.user.sessionId,
  timeout: state.config.timeout,
});

const mapDispatchToProps = {
  getUserDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionCheck);
